import React, { useState, useEffect } from "react";
import { Drawer, IconButton, Box, CircularProgress, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import { Document, Page, pdfjs } from "react-pdf";
import Mammoth from "mammoth";

pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";

type DocumentViewerProps = {
  open: boolean;
  onClose: () => void;
  fileUrl: string;
  fileType: "pdf" | "docx";
};

const DocumentViewerDrawer: React.FC<DocumentViewerProps> = ({
  open,
  onClose,
  fileUrl,
  fileType,
}) => {
  const [numPages, setNumPages] = useState<number | null>(null);
  const [docxContent, setDocxContent] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (fileType === "docx") {
      fetch(fileUrl)
        .then((response) => response.arrayBuffer())
        .then((arrayBuffer) => Mammoth.convertToHtml({ arrayBuffer }))
        .then((result) => {
          setDocxContent(result.value);
          setLoading(false);
        })
        .catch(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [fileUrl, fileType]);

  return (
    <Box>
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="80vh">
          <CircularProgress />
        </Box>
      ) : fileType === "pdf" ? (
        <iframe style={{ width: "99%", float: "left", height: "100vh" }} src={fileUrl}></iframe>
      ) : fileType === "docx" && docxContent ? (
        <Box
          sx={{
            overflow: "auto",
            p: 2,
            width: "100%",
            maxWidth: "100%",
            "& *": {
              maxWidth: "100%", // Limite la largeur des éléments internes
              wordWrap: "break-word", // Coupe les mots longs
              whiteSpace: "normal", // Permet le retour à la ligne
            },
          }}
          dangerouslySetInnerHTML={{ __html: docxContent }}
        />
      ) : (
        <Typography>Unsupported document type</Typography>
      )}
    </Box>
  );
};

export default DocumentViewerDrawer;
